<template>
  <div>
    <!-- Filters -->
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md4>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.contact_id"
            :items="[{ name: 'Mostrar todos', id: null }].concat(contactsList)"
            :label="$t('Contacto')"
            item-text="name"
            item-value="id"
            row
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.recursive_status"
            item-text="text"
            item-value="value"
            :items="recursiveStatusOptions"
            :clearable="true"
            row
            :label="$t('Estado')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2>
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.recursive_frequency"
            item-text="text"
            item-value="value"
            :items="recursiveFrequencyOptions"
            :clearable="true"
            row
            :label="$t('Frecuencia')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md4>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <!-- Data table with invoices -->
    <v-data-table
      ref="openBillingInvoiceTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="invoices"
      :pagination.sync="invoicesPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="invoicesPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                'text-xs-center',
                header.sortable ? 'column sortable' : '',
                invoicesPagination.descending ? 'desc' : 'asc',
                header.value === invoicesPagination.sortBy ? 'active' : '',
              ]"
              @click="header.sortable ? changeSort(header.value) : null"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :style="{ 'background-color': props.item.blocked ? '#eeeeee' : '' }">
          <td>
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td v-for="header in headers" :key="header.value" class="text-xs-center">
            <template v-if="header.value === 'total_amount'">
              {{ props.item[header.value].toString().replace('.', ',') + '€' }}
            </template>
            <template v-else-if="header.value === 'recursive_frequency'">
              {{
                recursiveFrequencyOptions.find(item => item.value === props.item[header.value]).text
              }}
            </template>
            <template
              v-else-if="
                header.value === 'recursive_start' ||
                  header.value === 'recursive_next' ||
                  header.value === 'recursive_end'
              "
            >
              {{ parseDate(props.item[header.value]) }}
            </template>
            <template v-else-if="header.value === 'recursive_status' && props.item[header.value]">
              <v-edit-dialog
                class="row-editable"
                :return-value.sync="props.item[header.value]"
                large
                lazy
                persistent
                :save-text="'Guardar'"
                :cancel-text="'Cancelar'"
                @save="saveRow(props.item)"
                @cancel="cancelSaveRow(props.item)"
                style="width: auto; display: inline-block"
              >
                <v-chip :color="getColorForStatus(props.item[header.value])" text-color="white">
                  <strong>{{ props.item[header.value] }}</strong>
                </v-chip>
                <template v-slot:input>
                  <div class="mt-3">Estado</div>
                  <v-select
                    color="primary"
                    v-model="props.item[header.value]"
                    item-text="text"
                    item-value="value"
                    :items="recursiveStatusOptions"
                    row
                  ></v-select>
                </template>
              </v-edit-dialog>
            </template>
            <template v-else>
              {{ props.item[header.value] }}
            </template>
          </td>
          <td class="text-xs-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">
                  <v-icon color="white">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="showInvoice(props.item)">
                  <v-list-tile-title>
                    <v-icon small class="mr-2">
                      mdi-eye
                    </v-icon>
                    VER
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="!props.item.rectify" @click="cloneInvoice(props.item)">
                  <v-list-tile-title>
                    <v-icon small class="mr-2">
                      mdi-file-document-multiple
                    </v-icon>
                    CLONAR
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="!props.item.blocked" @click="deleteInvoice(props.item)">
                  <v-list-tile-title>
                    <v-icon small class="mr-2">
                      mdi-delete
                    </v-icon>
                    ELIMINAR
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </div>
</template>

<script>
const moment = require('moment');
require('moment/locale/es');
import apiCtrl from '@/services/api/abstract/abstract-api';
import {
  recursiveStatus,
  recursiveFrequency,
  recursiveInvoiceType,
  recursiveInvoiceTableHeader,
} from '@/modules/openbilling/helpers/invoices';

export default {
  name: 'OpenBillingRecursiveInvoiceTable',
  components: {},
  props: ['year', 'quarter', 'invoiceType'],
  data() {
    return {
      invoices: [],
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      contactsList: [],
      availableMonthsForQuarter: [],
      availablePaymentMethods: [
        { text: 'No definido', value: 'No definido' },
        { text: 'Efectivo', value: 'Efectivo' },
        { text: 'Bizum', value: 'Bizum' },
        { text: 'Transferencia', value: 'Transferencia' },
        { text: 'Tarjeta bancaria', value: 'Tarjeta bancaria' },
        { text: 'Domiciliación bancaria', value: 'Domiciliación bancaria' },
        { text: 'Paypal', value: 'Paypal' },
      ],
      invoicesPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      filters: {
        search: '',
        contact_id: null,
        year: this.year,
        quarter: this.quarter,
        recursive_frequency: null,
        recursive_status: null,
      },
      sortTable: false,
      snack: false,
      snackText: '',
      snackColor: 'info',
    };
  },
  mounted() {
    this.getBillingInvoices();
    this.getContactsList();
  },
  computed: {
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    currentPage() {
      return this.invoicesPagination.page;
    },
    perPage() {
      return this.invoicesPagination.rowsPerPage;
    },
    sortBy() {
      return this.invoicesPagination.sortBy;
    },
    descending() {
      return this.invoicesPagination.descending;
    },
    selectedYear() {
      return this.year;
    },
    selectedQuarter() {
      return this.quarter;
    },
    search() {
      return this.filters.search;
    },
    selectedStatus() {
      return this.filters.recursive_status;
    },
    selectedContactId() {
      return this.filters.contact_id;
    },
    selectedFrequency() {
      return this.filters.recursive_frequency;
    },
    recursiveStatusOptions() {
      return recursiveStatus;
    },
    recursiveFrequencyOptions() {
      return recursiveFrequency;
    },
    headers() {
      return recursiveInvoiceTableHeader;
    },
  },
  methods: {
    parseDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getColorForStatus(status) {
      switch (status) {
        case 'Pausada':
          return '#53BDFF';
        case 'Activa':
          return '#00CC33';
        case 'Finalizada':
          return '#999999';
        default:
          return '#CCCCCC';
      }
    },
    getBillingInvoices() {
      this.loading = true;
      const config = {
        params: {
          page: this.invoicesPagination.page,
          per_page: this.invoicesPagination.rowsPerPage,
          sort_by: this.invoicesPagination.sortBy,
          descending: this.invoicesPagination.descending,
          search: this.search,
          recursive_status: this.selectedStatus,
          contact_id: this.selectedContactId,
          frequency: this.selectedFrequency,
          year: this.selectedYear,
          quarter: this.selectedQuarter,
          doc_type: recursiveInvoiceType,
        },
      };
      apiCtrl
        .get(`/openbilling/${this.clavedat}/invoices/${this.billingProfileId}/list`, config)
        .then(res => {
          this.selectAllRows = false;
          this.invoices = res.data.data;
          this.invoicesPagination = {
            descending: this.invoicesPagination.descending,
            page: this.invoicesPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.invoicesPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getContactsList() {
      const config = {
        params: {
          page: 1,
          per_page: -1,
          sort_by: 'name',
          descending: 'asc',
        },
      };
      apiCtrl
        .get(`/openbilling/${this.clavedat}/contacts/${this.billingProfileId}/list`, config)
        .then(res => {
          this.contactsList = res.data.data;
        })
        .catch(() => {});
    },
    selectAllTableRows() {
      if (this.selectAllRows) {
        let selected = [];
        this.invoices.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else {
        this.selectedItems = [];
      }
    },
    changeSort(column) {
      if (this.invoicesPagination.sortBy === column) {
        this.invoicesPagination.descending = !this.invoicesPagination.descending;
      } else {
        this.invoicesPagination.sortBy = column;
        this.invoicesPagination.descending = false;
      }
    },
    showInvoice(invoice) {
      this.$emit('on-show-invoice', invoice);
    },
    deleteInvoice(invoice) {
      this.$emit('on-delete-invoice', invoice);
    },
    cloneInvoice(invoice) {
      this.$emit('on-clone-invoice', invoice);
    },
    getBillingInvoicesIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.invoicesPagination.page,
        per_page: this.invoicesPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.invoicesPagination.page &&
          params.per_page === this.invoicesPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getBillingInvoices();
        }
      }, 300);
    },
    saveRow(item) {
      // Update the row entity in backend
      apiCtrl
        .post(`/openbilling/${this.clavedat}/invoices/update/${item.id}/recursive-status`, {
          recursive_status: item.recursive_status,
        })
        .then(() => {
          this.showSnackMessage('success', 'Se ha actualizado el estado correctamente');
        })
        .catch(() => {
          this.showSnackMessage('error', 'Se ha producido un error al actualizar');
          this.getBillingInvoices();
        });
    },
    cancelSaveRow() {},
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    formatBlockedDateTime(dateTime) {
      return moment(dateTime).format('DD/MM/YYYY HH:mm');
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getBillingInvoicesIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getBillingInvoices();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getBillingInvoices();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedFrequency: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedContactId: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedStatus: function() {
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedYear: function() {
      this.filters.year = this.selectedYear;
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedQuarter: function() {
      this.filters.quarter = this.selectedQuarter;
      if (this.currentPage === 1) {
        this.getBillingInvoicesIfStopChanges();
      } else {
        this.invoicesPagination.page = 1;
      }
    },
    selectedItems: function() {
      this.$emit('on-selected-items', this.selectedItems);
    },
    selectAllRows: function() {
      if (!this.selectAllRows) {
        this.selectedItems = [];
      }
    },
  },
};
</script>

<style scoped>
.bg-disabled {
  background-color: #eeeeee !important;
}
.v-menu__activator {
  justify-content: center !important;
}
</style>
